import { InputLabel, MenuItem } from '@mui/material';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ValoreDominioVO } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface ListVerificationTypeProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (value?: ItemVM) => void;
  error?: boolean;
  isSmallSize?: boolean;
  withoutFiglio?: boolean;
  only1and2?: boolean;
}

const ListVerificationTypeComponent = ({
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
  withoutFiglio = false,
  only1and2 = false,
}: ListVerificationTypeProps): React.ReactElement => {
  const [verificationTypes] = useHttpFetch<HttpResponse<Array<ValoreDominioVO>>, Array<ItemVM>>(
    `${__ACT_API_URL__}/filtri/dominio/78`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
      },
      transformer: (response) =>
        ((response.data.payload || []) as Array<ValoreDominioVO>).map((item) => ({
          id: item.key?.idValore,
          value: item.descrizioneValore,
        })) as Array<ItemVM>,
    }
  );

  const verificationTypeData: Array<ItemVM> = useMemo(() => {
    return ((verificationTypes.data || []) as Array<ItemVM>).filter((item) => {
      if (only1and2) {
        return item.id === '1' || item.id === '2';
      }

      if (withoutFiglio) {
        return item.id !== '4';
      }

      // non ci sono limitazioni
      return true;
    });
  }, [verificationTypes, withoutFiglio, only1and2]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="verificationType-label">
        {required ? 'Tipo accertamento *' : 'Tipo accertamento'}
      </InputLabel>
      <PmiSelect
        labelId="verificationType-label"
        id="verificationType"
        name="verificationType"
        value={value}
        label={required ? 'Tipo accertamento *' : 'Tipo accertamento'}
        onChange={(event) =>
          onChange(verificationTypeData?.find((item) => item.id === event.target.value))
        }
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {verificationTypeData?.map((verificationType: ItemVM) => (
          <MenuItem key={verificationType.id} value={verificationType.id}>
            {verificationType.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListVerificationTypeComponent.displayName = 'List Verification Type component';

const ListVerificationType = memo(ListVerificationTypeComponent);

export default ListVerificationType as typeof ListVerificationTypeComponent;
